import React, { Component } from "react";

import {
  CButton,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CInput,
  CSpinner,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Card, CardBody, CardGroup, Col, Container, Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { login, tryLogin } from "../../actions/baseActions";
import logo from "../../assets/imgs/logo_original.png";
import LoginForm from "../../components/Forms/LoginForm";
import URL from "../../config/api";
import axios from "../../config/axios";

import "./style.css";

class Guest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      login: true,
      name: "",
      username: "",
      password: "educandus",
      loading: false,
      email: "",
      // emailShow: false,
      allocation: this.props.match.params.allocation_id || null,
      activity_id: this.props.match.params.activity_id || null,
      room: "",
      group: "",
      region: "",
      school: "",
      schoolName: "",
      roomName: "",
      // chooseSchool: false,
      schoolLoading: false,
      showActivityInfo: false
    };
  }

  componentDidMount() {
    this.props.tryLogin(false);
    if (this.state.allocation !== null || this.state.activity_id !== null)
      this.getSchoolList();
  }

  getSchoolList() {
    try {
      this.setState({ schoolLoading: true });
      const type =
        this.state.activity_id !== null
          ? this.state.activity_id
          : this.state.allocation;
      const routeType =
        this.state.activity_id !== null
          ? `activitySchoolListAll/`
          : `activitySchoolList/`;

      axios.get(`${URL.api}${routeType}${type}`, {}).then(resp => {
        let data = resp.data;
        if (
          data &&
          data.success &&
          data.data.group_id &&
          data.data.region_id &&
          data.data.room_id &&
          data.data.school_id &&
          data.data.school_name &&
          data.data.room_name
        ) {
          this.setState({
            group: resp.data.data.group_id,
            region: resp.data.data.region_id,
            room: resp.data.data.room_id,
            school: resp.data.data.school_id,
            schoolName: resp.data.data.school_name,
            roomName: resp.data.data.room_name
          });
          // eslint-disable-next-line react/no-unused-state
          this.setState({ schoolList: resp.data.data });
          this.setState({ schoolLoading: false, showActivityInfo: true });
        } else {
          this.setState({ schoolLoading: false, showActivityInfo: false });
        }
      });
    } catch (e) {
      this.setState({ schoolLoading: false, showActivityInfo: false });
    }
  }

  registerGuest() {
    if (this.state.name === "") {
      toastr.error("Erro", "Você precisa preencher o campo Nome.");
    } else {
      this.setState({ loading: true });

      axios
        .post(
          `${URL.api}guest`,
          {
            name: this.state.name,
            email: this.state.email,
            group: this.state.group,
            region: this.state.region,
            school: this.state.school,
            room: this.state.room
          },
          null
        )
        .then(resp => {
          this.setState({ username: resp.data.data, loading: false });
        });
    }
  }

  doLogin() {
    this.setState({ loading: true });
    this.props.login({
      username: this.state.username,
      password: this.state.password
    });
  }

  render() {
    const { login } = this.props;

    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="5">
              <Card className="p-4 m-0">
                <CardBody>
                  <div className="d-flex justify-content-start mb-4">
                    <img src={logo} alt="logo da empresa" />
                  </div>
                  {this.state.login ? (
                    <>
                      {!this.state.schoolLoading ? (
                        <>
                          <h1>Entre</h1>
                          <p className="text-muted">
                            Para entrar na sua conta, digite seus dados
                          </p>
                          {this.state.showActivityInfo && (
                            <div className="card p-3">
                              <span>Escola:</span>
                              <p>
                                <b>{this.state.schoolName}</b>
                              </p>
                              <span>Turma:</span>
                              <p>
                                <b>{this.state.roomName}</b>
                              </p>
                            </div>
                          )}
                          <LoginForm
                            onSubmit={login}
                            loading={this.props.general.tryLogin}
                            showLogo={false}
                          />
                          <div className="text-muted text-center my-2">ou</div>
                          <CButton
                            variant="outline"
                            color="primary"
                            className="p-2"
                            block
                            onClick={() => this.setState({ login: false })}
                          >
                            Entrar como visitante
                          </CButton>
                        </>
                      ) : (
                        <>
                          <CSpinner
                            size="sm"
                            color="white"
                            style={{ position: "absolute" }}
                          />
                        </>
                      )}
                    </>
                  ) : !this.state.schoolLoading ? (
                    this.state.username === "" ? (
                      <>
                        <h1>Bem-vindo</h1>
                        <p className="text-muted">
                          Para entrar como visitante, preencha os campos abaixo.
                        </p>
                        <CFormGroup className="mb-0">
                          <CInputGroup>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-user"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              placeholder="Nome"
                              value={this.state.name}
                              onChange={e =>
                                this.setState({ name: e.target.value })
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                        <CFormGroup className="mb-0 mt-3">
                          <CInputGroup>
                            <CInputGroupPrepend>
                              <CInputGroupText>
                                <i className="fa fa-envelope"></i>
                              </CInputGroupText>
                            </CInputGroupPrepend>
                            <CInput
                              placeholder="E-mail"
                              value={this.state.email}
                              onChange={e =>
                                this.setState({ email: e.target.value })
                              }
                            />
                          </CInputGroup>
                        </CFormGroup>
                        <CFormGroup className="mb-0 mt-3">
                          {this.state.showActivityInfo && (
                            <div className="card p-3">
                              <span>Escola:</span>
                              <p>
                                <b>{this.state.schoolName}</b>
                              </p>
                              <span>Turma:</span>
                              <p>
                                <b>{this.state.roomName}</b>
                              </p>
                            </div>
                          )}
                        </CFormGroup>
                        <span className="text-muted mb-3 float-right">
                          *Preencher o e-mail é opcional
                        </span>
                        <CButton
                          color="primary"
                          className="d-flex justify-content-center align-items-center p-2"
                          block
                          onClick={() => this.registerGuest()}
                        >
                          <>
                            <span
                              style={this.state.loading ? { opacity: 0 } : null}
                            >
                              Continuar
                            </span>
                            {this.state.loading && (
                              <CSpinner
                                size="sm"
                                color="white"
                                style={{ position: "absolute" }}
                              />
                            )}
                          </>
                        </CButton>
                        <div className="text-muted text-center my-2">ou</div>
                        <CButton
                          variant="outline"
                          color="primary"
                          className="p-2"
                          block
                          onClick={() => this.setState({ login: true })}
                        >
                          Entrar com sua conta Educandus
                        </CButton>
                      </>
                    ) : (
                      <div className="p-3">
                        <div className="card">
                          <div className="card-header">
                            <h3>Seu acesso:</h3>
                          </div>
                          <div className="card-body">
                            <span>Seu usuário é:</span>
                            <h4>{this.state.username}</h4>
                            <hr />
                            <span>Sua senha:</span>
                            <h4>{this.state.password}</h4>
                          </div>
                        </div>
                        <p>
                          <b>Importante: </b>guarde bem seu usuário e senha para
                          que você possa recuperar o acesso em casos como perda
                          de conexão com a internet.
                        </p>
                        <br />
                        <CButton
                          color="primary"
                          className="d-flex justify-content-center align-items-center p-2"
                          block
                          onClick={() => this.doLogin()}
                        >
                          <>
                            <span
                              style={this.state.loading ? { opacity: 0 } : null}
                            >
                              Continuar
                            </span>
                            {this.state.loading && (
                              <CSpinner
                                size="sm"
                                color="white"
                                style={{ position: "absolute" }}
                              />
                            )}
                          </>
                        </CButton>
                      </div>
                    )
                  ) : (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = state => ({ general: state.general });

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      login,
      tryLogin
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Guest);
